import React, { useState, useEffect } from "react";
import {Modal, Typography, Form, Card, Radio, Input} from "antd";
import TableModalReturnPickupOrders from "./tableModalReturnPickupOrders/tableModalReturnPickupOrders";
import { validationErrors } from "../../../../../../utils/Helpers";

import * as orderManagementActions from "../../../../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { swalNotification } from "../../../../../../components/alret/notificztion";

const { Title, Text } = Typography;

const ModalReturnPickupOrders = (props) => {
  const [postDataOrderView, setPostDataOrderView] = useState({});
  const [postDataOrdersend, setPostDataOrderSend] = useState(undefined);
  const [postDataOrdersendNew, setPostDataOrderSendNew] = useState(undefined);
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.visible) {
      setMBtnLoading(true);
      setPostDataOrderView(props?.orderData[0]);
      setPostDataOrderSend(props?.orderData[0]?.order_details?.order_items)
      form.setFieldsValue(props?.orderData[0]?.order_details);
      setMBtnLoading(false);
    }
  }, [props.visible]);

  const handleCancel = () => {
    setPostDataOrderView({})
    setPostDataOrderSend(undefined)
    setPostDataOrderSendNew(undefined)
    form.resetFields();
    props.setvisible(false);
  };
  // Modal Form

  const onCreateAction = async (value) => {
    try {
      const newItem = postDataOrdersendNew.map((item, i)=>{
        if(item.selected === true){
          const {selected, index, orgQuantity, orgPrice, ...rest} = item;
          return rest;
        }
      }).filter((e)=>e);
      const {is, ...reset} = value
      const newData = {
        ...reset,
        is_return: value?.is === "is_return" ? 1 : 0,
        is_replace: value?.is === "is_replace" ? 1 : 0,
        order_items: newItem
      }
      // console.log("newData", newData)
      // return null
      await props.orderManagementActions.getReturnPickupOrdersAction( props?.orderData[0]?.order_id, newData);
      swalNotification(
        "Return Pickup",
        "Return pickup order has been created",
        "success"
      );
      handleCancel()
    } catch(e) {
      validationErrors(e)
    }
  }
  const [limit, setLimit] = useState({});
  const limitChange = (value, name) => {
    setLimit((limit)=>({
      ...limit,
      [name]: value,
    }))
  }

  // console.log("limit", limit)

   return (
    <Modal
      title={`Order# ${postDataOrderView?.order_id}`}
      visible={props.visible}
      confirmLoading={MBtnLoading}
      cancelText="Cancel"
      onCancel={handleCancel}
      okText="Submit"
      onOk={
        () => {form.validateFields().then((values) => {
          // form.resetFields();
          onCreateAction(values);
        }).catch((e) => {
          // console.log('Validate Failed:', e);
        });
      }}
    >
      <div>
        <Title level={5}>Pickup Location:</Title>
        <Text>{postDataOrderView?.pickup?.address}</Text>
      </div>
      <div>
        <Title level={5}>Delivery Location:</Title>
        <Text>{postDataOrderView?.delivery?.address}</Text>
      </div>
      <Card>
        <TableModalReturnPickupOrders data={postDataOrdersend} send={setPostDataOrderSendNew} />
        <Form form={form} layout="vertical" initialValues={{ modifier: 'public', }}>
          <Form.Item name={"is"} rules={[{required: true, message: "Please select one"}]}>
            <Radio.Group onChange={(val)=>limitChange(val?.target?.value, "is")}>
              <Radio value="is_return">Pickup Only</Radio>
              <Radio value="is_replace">Exchange</Radio>
            </Radio.Group>
          </Form.Item>
          {limit?.is === "is_replace" &&
          <Form.Item name={"new_exchange_order_id"} label={"Order id"} rules={[{required: true, message: "Please select one"}]}>
            <Input/>
          </Form.Item>
          }
        </Form>
      </Card>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators(orderManagementActions, dispatch),
  };
};
 export default connect(mapStateToProps, mapDispatchToProps)(ModalReturnPickupOrders);
// export default ModalReturnPickupOrders;
